import { LocalisationDictionary } from '../../services/localisationContext';
import { callApi } from '../../utils/callApi';

export const getTranslations = async (locale: string): Promise<LocalisationDictionary | null> => {
  const response = await callApi<LocalisationDictionary>(
    `/localizations/be-configurator.${locale}.json`,
  );
  const { data = null } = response || {};
  return data;
};
